module.exports = __webpack_public_path__ + "img/lv_failure_1.a766253b.png";